let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("81fNp")).then(() => parcelRequire('ep6Xe'));